export default __webpack_public_path__ + "static/media/122.241628b8.png";